var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EButton',{staticClass:"ad-extension-action",attrs:{"as":"a","href":_vm.url,"variant":"outline","size":"s","rel":"noopener","target":_vm.linkTarget,"data-test-id":"ad-extension-action"}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }